let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("km7JB")).then(() => parcelRequire('dz9Sq'));